export const ar = {
  // General
  app_name: "نماء",
  admin_panel: "لوحة الإدارة",
  dashboard: "الرئيسية",
  save: "حفظ",
  cancel: "إلغاء",
  delete: "حذف",
  edit: "تعديل",
  add: "إضافة",
  search: "بحث",
  filter: "تصفية",
  actions: "الإجراءات",
  loading: "جاري التحميل...",
  no_data: "لا توجد بيانات",
  confirm_delete: "هل أنت متأكد من الحذف؟",
  yes: "نعم",
  no: "لا",
  status: "الحالة",
  active: "نشط",
  inactive: "غير نشط",
  created_at: "تاريخ الإنشاء",
  updated_at: "تاريخ التحديث",
  view: "عرض",
  back: "رجوع",
  close: "إغلاق",
  submit: "إرسال",
  reset: "إعادة تعيين",
  export: "تصدير",
  import: "استيراد",
  download: "تحميل",
  upload: "رفع",
  select: "اختر",
  all: "الكل",
  none: "لا شيء",
  required: "مطلوب",
  optional: "اختياري",
  
  // Auth
  login: "تسجيل الدخول",
  logout: "تسجيل الخروج",
  username: "اسم المستخدم",
  password: "كلمة المرور",
  login_title: "تسجيل الدخول للوحة الإدارة",
  login_subtitle: "أدخل بيانات الاعتماد الخاصة بك",
  invalid_credentials: "بيانات الاعتماد غير صحيحة",
  
  // Navigation
  nav: {
    dashboard: "الرئيسية",
    master_data: "البيانات الأساسية",
    regions: "المناطق",
    cities: "المدن",
    districts: "الأحياء",
    categories: "التصنيفات",
    subcategories: "التصنيفات الفرعية",
    map_categories: "تصنيفات الخريطة",
    projects: "المشاريع",
    outlets: "منافذ البيع",
    success_stories: "قصص النجاح",
    statistics: "الإحصائيات",
    stat_definitions: "تعريفات الإحصائيات",
    stat_values: "قيم الإحصائيات",
    region_statistics: "إحصائيات المناطق",
    import_center: "مركز الاستيراد",
    import_history: "سجل الاستيراد",
    import_errors: "أخطاء الاستيراد",
    review_queue: "قائمة المراجعة",
    media: "الملفات",
    aliases: "الأسماء البديلة",
    settings: "الإعدادات",
  },
  
  // Dashboard
  total_projects: "إجمالي المشاريع",
  total_outlets: "إجمالي المنافذ",
  total_regions: "إجمالي المناطق",
  total_cities: "إجمالي المدن",
  pending_reviews: "في انتظار المراجعة",
  import_errors_count: "أخطاء الاستيراد",
  published_projects: "المشاريع المنشورة",
  sample_projects: "المشاريع التجريبية",
  projects_by_region: "المشاريع حسب المنطقة",
  recent_imports: "آخر عمليات الاستيراد",
  
  // Regions
  regions: "المناطق",
  region: "المنطقة",
  add_region: "إضافة منطقة",
  edit_region: "تعديل المنطقة",
  region_name_ar: "اسم المنطقة بالعربية",
  region_name_en: "اسم المنطقة بالإنجليزية",
  
  // Cities
  cities: "المدن",
  city: "المدينة",
  add_city: "إضافة مدينة",
  edit_city: "تعديل المدينة",
  city_name_ar: "اسم المدينة بالعربية",
  city_name_en: "اسم المدينة بالإنجليزية",
  select_region: "اختر المنطقة",
  
  // Districts
  districts: "الأحياء",
  district: "الحي",
  add_district: "إضافة حي",
  edit_district: "تعديل الحي",
  district_name_ar: "اسم الحي بالعربية",
  district_name_en: "اسم الحي بالإنجليزية",
  select_city: "اختر المدينة",
  
  // Categories
  categories: "التصنيفات",
  category: "التصنيف",
  add_category: "إضافة تصنيف",
  edit_category: "تعديل التصنيف",
  category_name_ar: "اسم التصنيف بالعربية",
  category_name_en: "اسم التصنيف بالإنجليزية",
  category_code: "رمز التصنيف",
  category_icon: "أيقونة التصنيف",
  display_order: "ترتيب العرض",
  
  // SubCategories
  subcategories: "التصنيفات الفرعية",
  subcategory: "التصنيف الفرعي",
  add_subcategory: "إضافة تصنيف فرعي",
  edit_subcategory: "تعديل التصنيف الفرعي",
  subcategory_name_ar: "اسم التصنيف الفرعي بالعربية",
  subcategory_name_en: "اسم التصنيف الفرعي بالإنجليزية",
  select_category: "اختر التصنيف",
  
  // Projects
  projects: "المشاريع",
  project: "المشروع",
  add_project: "إضافة مشروع",
  edit_project: "تعديل المشروع",
  project_name_ar: "اسم المشروع بالعربية",
  project_name_en: "اسم المشروع بالإنجليزية",
  latitude: "خط العرض",
  longitude: "خط الطول",
  icon_name: "اسم الأيقونة",
  icon_code: "رمز الأيقونة",
  project_status: "حالة المشروع",
  review_status: "حالة المراجعة",
  data_source: "مصدر البيانات",
  notes: "ملاحظات",
  is_sample: "مشروع تجريبي",
  draft: "مسودة",
  published: "منشور",
  archived: "مؤرشف",
  pending: "في الانتظار",
  approved: "موافق عليه",
  rejected: "مرفوض",
  select_subcategory: "اختر التصنيف الفرعي",
  select_district: "اختر الحي",
  
  // Outlets
  outlets: "منافذ البيع",
  outlet: "منفذ البيع",
  add_outlet: "إضافة منفذ بيع",
  edit_outlet: "تعديل منفذ البيع",
  outlet_name_ar: "اسم المنفذ بالعربية",
  outlet_name_en: "اسم المنفذ بالإنجليزية",
  outlet_category: "تصنيف المنفذ",
  project_info: "معلومات المشروع",
  classification_number: "رقم التصنيف",
  
  // Statistics
  statistics: "الإحصائيات",
  stat_definitions: "تعريفات الإحصائيات",
  stat_values: "قيم الإحصائيات",
  add_stat_definition: "إضافة تعريف إحصائية",
  edit_stat_definition: "تعديل تعريف الإحصائية",
  stat_code: "رمز الإحصائية",
  stat_name_ar: "اسم الإحصائية بالعربية",
  stat_name_en: "اسم الإحصائية بالإنجليزية",
  stat_description: "وصف الإحصائية",
  stat_type: "نوع الإحصائية",
  stat_icon: "أيقونة الإحصائية",
  applies_to: "تنطبق على",
  scope_type: "نوع النطاق",
  scope_id: "معرف النطاق",
  value_numeric: "القيمة الرقمية",
  value_text: "القيمة النصية",
  period_label: "فترة البيانات",
  source: "المصدر",
  is_published: "منشور",
  number: "رقم",
  percentage: "نسبة مئوية",
  currency: "عملة",
  text: "نص",
  global: "عام",
  
  // Import
  import_center: "مركز الاستيراد",
  import_history: "سجل الاستيراد",
  import_errors: "أخطاء الاستيراد",
  upload_file: "رفع ملف",
  select_import_type: "اختر نوع الاستيراد",
  import_type: "نوع الاستيراد",
  drop_file_here: "اسحب الملف هنا أو انقر للاختيار",
  supported_formats: "الصيغ المدعومة: Excel (.xlsx, .xls), JSON (.json)",
  file_uploaded: "تم رفع الملف",
  process_import: "معالجة الاستيراد",
  import_status: "حالة الاستيراد",
  total_rows: "إجمالي الصفوف",
  success_rows: "صفوف ناجحة",
  error_rows: "صفوف بها أخطاء",
  completed: "مكتمل",
  completed_with_errors: "مكتمل مع أخطاء",
  processing: "قيد المعالجة",
  failed: "فشل",
  row_number: "رقم الصف",
  error_type: "نوع الخطأ",
  error_message: "رسالة الخطأ",
  
  // Review Queue
  review_queue: "قائمة المراجعة",
  entity_type: "نوع الكيان",
  issue_type: "نوع المشكلة",
  original_value: "القيمة الأصلية",
  suggested_value: "القيمة المقترحة",
  resolution_notes: "ملاحظات الحل",
  approve: "موافقة",
  reject: "رفض",
  resolve: "حل",
  
  // Media
  media_library: "مكتبة الملفات",
  upload_media: "رفع ملف",
  file_name: "اسم الملف",
  file_size: "حجم الملف",
  file_type: "نوع الملف",
  uploaded_by: "رفع بواسطة",
  uploaded_at: "تاريخ الرفع",
  
  // Aliases
  aliases: "الأسماء البديلة",
  add_alias: "إضافة اسم بديل",
  alias_value: "القيمة البديلة",
  master_record: "السجل الرئيسي",
  master_name: "الاسم الرئيسي",
  
  // Validation Messages
  validation: {
    required: "هذا الحقل مطلوب",
    invalid_email: "البريد الإلكتروني غير صحيح",
    min_length: "الحد الأدنى للطول هو {min} أحرف",
    max_length: "الحد الأقصى للطول هو {max} حرف",
    invalid_coordinates: "الإحداثيات غير صحيحة",
    subcategory_mismatch: "التصنيف الفرعي لا يتبع التصنيف المختار",
    city_mismatch: "المدينة لا تتبع المنطقة المختارة",
    district_mismatch: "الحي لا يتبع المدينة المختارة",
  },
  
  // Success Messages
  success: {
    created: "تم الإنشاء بنجاح",
    updated: "تم التحديث بنجاح",
    deleted: "تم الحذف بنجاح",
    imported: "تم الاستيراد بنجاح",
    uploaded: "تم الرفع بنجاح",
  },
  
  // Error Messages
  error: {
    general: "حدث خطأ، يرجى المحاولة مرة أخرى",
    not_found: "العنصر غير موجود",
    unauthorized: "غير مصرح لك بهذا الإجراء",
    delete_has_children: "لا يمكن الحذف لوجود عناصر تابعة",
  },
};
